export default "__VITE_ASSET__BfRie_0G__"